import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../assets/css/BreadcrumbSection.css";

const BreadcrumbSection = ({
  title,
  subtitle,
  breadcrumbItems = [],
  backgroundImage,
}) => {
  const location = useLocation();

  // Extract last segment of path (e.g., "/about-us" → "About Us")
  const currentPath = location.pathname.split("/").filter(Boolean).pop();
  const formattedCurrent =
    currentPath?.charAt(0).toUpperCase() + currentPath?.slice(1).replace(/-/g, " ");

  // Combine given breadcrumbs + detected one (if not already included)
  const fullBreadcrumbs =
    breadcrumbItems.length > 0 &&
    breadcrumbItems[breadcrumbItems.length - 1].label.toLowerCase() ===
      formattedCurrent?.toLowerCase()
      ? breadcrumbItems
      : [
          ...breadcrumbItems,
          { label: formattedCurrent || "Home", to: location.pathname },
        ];

  return (
    <section
      className="breadcrumb-section"
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <div className="breadcrumb-overlay">
        <div className="container text-white text-start breadcrumb-content">
          {subtitle && <p className="breadcrumb-subtitle">{subtitle}</p>}
          {title && <h1 className="breadcrumb-title">{title}</h1>}

          <nav aria-label="breadcrumb" className="breadcrumb-nav">
            <ol className="breadcrumb">
              {fullBreadcrumbs.map((item, index) => (
                <li
                  key={index}
                  className={`breadcrumb-item ${
                    index === fullBreadcrumbs.length - 1 ? "active" : ""
                  }`}
                  aria-current={
                    index === fullBreadcrumbs.length - 1 ? "page" : undefined
                  }
                >
                  {item.to && index !== fullBreadcrumbs.length - 1 ? (
                    <Link to={item.to}>{item.label}</Link>
                  ) : (
                    item.label
                  )}
                </li>
              ))}
            </ol>
          </nav>
        </div>
      </div>
    </section>
  );
};

export default BreadcrumbSection;
